import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
export const addGrid = (self, grid) => {
  if (self._grids.has(grid.id)) {
    throw new Error(`이미 존재하는 grid 입니다.`);
  }
  const clip_path_el = self._getClipPathElThrowable();
  const empty_grid_layer_el = self._getEmptyGridLayerElThrowable();
  const target_image_layer_el = self._getTargetImageLayerElThrowable();
  const view_port = self._getViewPortThrowable();
  const view_box = self._getViewBoxThrowable();
  const dummy_g_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  dummy_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "target-image-dummy-g";
  const stroke = new StrokeNS.ModelNS.Stroke({
    svg_el: self._svg_el,
    getCTM: () => {
      const dummy_g_el_ctm = dummy_g_el.getCTM();
      if (dummy_g_el_ctm == null) {
        throw new Error(`해당 이미지의 CTM 을 구할 수 없습니다.`);
      }
      const target_image_layer_el_ctm = target_image_layer_el.getCTM();
      if (target_image_layer_el_ctm == null) {
        throw new Error(`해당 이미지의 CTM 을 구할 수 없습니다.`);
      }
      return target_image_layer_el_ctm.multiply(dummy_g_el_ctm);
    },
  });
  const stroke_sync = new StrokeNS.ModelNS.StrokeSync({
    el: dummy_g_el,
    SVGGraphicsElement: self._window.SVGGraphicsElement,
    stroke,
  });
  view_port.subscribe(() => stroke_sync.sync());
  view_box.subscribe(() => stroke_sync.sync());
  clip_path_el.appendChild(grid.clip_path_el);
  empty_grid_layer_el.appendChild(grid.empty_grid_el);
  self._grids.set(grid.id, {
    ...grid,
    target_image_el: null,
    dummy_g_el,
    stroke_sync,
  });
};
